/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

SET_PURCHASEORDERS(state, items) {

      state.PurchaseOrders = items;
    } ,
  SET_PURCHASEORDERSTATUS(state, items) {
      state.PurchaseOrderStatus = items;
    } ,
  

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.Tokens.findIndex((p) => p.Id == itemId)
      state.Tokens.splice(ItemIndex, 1)
  },
}
